import { useContext, useCallback } from 'react';
import I18nContext from '../components/I18nContext';

export const replaceVars = (variables: Record<string, any>, value: string) => {
  if (!variables) return value;

  // eslint-disable-next-line no-useless-escape
  const regExpFactory = (key: string) => new RegExp(`\{${key}\}`, 'ig');

  return Object.keys(variables).reduce(
    (i18nVal, key) => i18nVal.replace(regExpFactory(key), variables[key]),
    value,
  );
};

export default function useI18n() {
  const context = useContext(I18nContext);
  return useCallback(
    (
      // @TODO: this is bonkers!
      rawValue: null | boolean | undefined | string | TemplateStringsArray,
      defaultValue?: string,
      variables?: Record<string, any>,
    ): string | undefined => {
      if (!rawValue && !defaultValue) return undefined;
      let value: string | null | undefined;
      if (typeof rawValue === 'string') {
        value = rawValue;
      } else if (typeof rawValue === 'boolean') {
        value = null;
      } else if (rawValue == null || typeof rawValue === 'undefined') {
        value = rawValue as unknown as string;
      } else {
        value = rawValue.join('');
      }
      const i18nVal = context[value] || context[defaultValue];

      if (!i18nVal) {
        const fallback = replaceVars(
          variables,
          typeof defaultValue !== 'undefined' ? defaultValue : value,
        );
        if (defaultValue !== null && process.env.NODE_ENV !== 'test') {
          // eslint-disable-next-line no-console
          console.warn(`Missing i18n value for key ${fallback}, using key instead`);
        }
        return fallback;
      }
      return replaceVars(variables, i18nVal);
    },
    [context],
  );
}

export type I18n = ReturnType<typeof useI18n>;
